import { useTranslation } from 'react-i18next';
import { Event } from '../../../../../../types/psychometric';
import EventItem from './EventItem';

interface EventSectionProps {
  events: Event[];
}

export function EventSection({ events }: EventSectionProps) {
  const { t } = useTranslation();
  if (!events?.length) return null;

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">{t('profile.events')}</h2>
      <div className="space-y-8">
        {events.map((event, index) => (
          <EventItem key={index} event={event} />
        ))}
      </div>
    </div>
  );
}
